module.exports = __webpack_public_path__ + "img/28.4aaeecc6.png";